import {
  AppBar,
  Box,
  Drawer,
  Grid,
  IconButton,
  Stack,
  Typography,
  Divider,
} from "@mui/material";
import { ThemeSwitch } from "../generic/ThemeSwitch";
import { ListIcon } from "@phosphor-icons/react";
import { PAGE_LIST } from "../../enums/pageEnums";
import { useLocation, useNavigate } from "react-router-dom";
import { ResumeButton } from "../generic/ResumeButton";
import { useState } from "react";
import { DARK } from "../../enums/themeEnums";

export const TopBar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [openDrawer, setOpenDrawer] = useState(false);

  const toggleDrawer = () => {
    setOpenDrawer((prev) => !prev);
  };

  const PageListComponent = () => {
    return (
      <Stack
        direction={{ xs: "column", md: "row" }}
        gap={{ xs: 1.5, md: 3 }}
        alignItems={{ xs: "flex-start", sm: "flex-start", md: "center" }}
        color={"text.primary"}
      >
        {PAGE_LIST.map((page) => {
          const isActive = location.pathname === page.path;
          return (
            <Typography
              fontSize={"14px"}
              key={page.path}
              fontWeight={isActive ? 700 : 300}
              color={isActive ? "primary" : "text.secondary"}
              onClick={() => navigate(page.path)}
              sx={{
                cursor: "pointer",
                transition: "color 0.2s",
                "&:hover": { color: "text.primary" },
              }}
            >
              {page.name}
            </Typography>
          );
        })}
        <ResumeButton />
        <Box
          sx={{
            display: { xs: "none", sm: "none", md: "flex" },
            alignItems: "center",
            gap: 2,
          }}
        >
          <Divider
            orientation="vertical"
            flexItem
            sx={{ height: 20, my: "auto", mx: 0.5 }}
          />
          <ThemeSwitch />
        </Box>
      </Stack>
    );
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        background: (theme) =>
          theme.palette.mode === DARK
            ? theme.palette.background.default
            : theme.palette.background.default,
        boxShadow: "none",
        py: 2,
        px: { xs: 3, sm: 6, md: 10, lg: 25 },
        borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
      }}
    >
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <Typography
            sx={{
              cursor: "pointer",
              transition: "transform 0.15s cubic-bezier(0.4,0,0.2,1)",
              "&:hover": {
                transform: "scale(1.06)",
              },
            }}
            variant="h6"
            color="primary"
            fontWeight={900}
            onClick={() => navigate("/")}
          >
            &lt;/&gt; dev-jenmar.
          </Typography>
        </Grid>
        <Grid item>
          <Box sx={{ display: { xs: "none", sm: "none", md: "flex" } }}>
            <PageListComponent />
          </Box>
          <IconButton
            onClick={() => toggleDrawer()}
            color="primary"
            sx={{ display: { xs: "flex", sm: "flex", md: "none" } }}
          >
            <ListIcon size={20} weight="bold" />
          </IconButton>
        </Grid>
      </Grid>
      <Drawer
        anchor={"right"}
        open={openDrawer}
        onClose={() => toggleDrawer()}
        sx={{
          "& .MuiDrawer-paper": {
            boxShadow: "none",
            padding: "24px",
            width: "260px",
          },
        }}
      >
        <Stack direction={"column"} gap={2} mb={3}>
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Typography variant="h6">Menu</Typography>
            <Stack direction={"row"} gap={1}>
              <ThemeSwitch />
            </Stack>
          </Stack>
        </Stack>
        <PageListComponent />
      </Drawer>
    </AppBar>
  );
};
